import { Popover, Transition } from "@headlessui/react";
import React, { useState, Fragment } from "react";
import {
  UserCircleIcon,
  ChatBubbleBottomCenterTextIcon,
  HeartIcon,
  HomeIcon,
  ArrowRightOnRectangleIcon,
  LifebuoyIcon,
  QrCodeIcon,
  ShoppingCartIcon,
  UserPlusIcon,
  Bars3Icon,
  ChevronRightIcon,
  ArrowRightIcon,
} from "@heroicons/react/24/outline";
import { Link, useNavigate } from "react-router-dom";
import Avatar from "shared/Avatar/Avatar";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/authSlice";
import QRCode from "react-qr-code";
import { RootState } from "../../redux/store";
import { toast } from "react-toastify";
import { setAuthModalOpen } from "../../redux/features/authModalSlice";
import { LOKALAI_MENU, LOKALAI_MENU_Nologin } from "data/navigation";
import { Disclosure } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/24/solid";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import LangDropdown from "./LangDropdown";

const solutions = [
  {
    name: "Dashboard",
    href: "/dashboard",
    icon: UserCircleIcon,
  },

  {
    name: "Messages",
    href: "/userInbox",
    icon: ChatBubbleBottomCenterTextIcon,
  },

  {
    name: "Your QR",
    href: "/qr-code",
    icon: QrCodeIcon,
  },
];

const nologin = LOKALAI_MENU_Nologin;

const solutionsFoot = [
  {
    name: "Help",
    href: "##",
    icon: LifebuoyIcon,
  },
];

export default function AvatarDropdown() {
  const user = useSelector((state: RootState) => state.auth.user);

  // console.log({ user });

  const className = "p-2.5 text-neutral-700 dark:text-neutral-300";
  const iconClassName = "h-7 w-7 fill-black dark:fill-white";

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    dispatch(logout());
    toast.success("Log out successfully");
    navigate("/");
  };

  const handleLinkClick = (
    e: React.MouseEvent<HTMLAnchorElement>,
    href: string
  ) => {
    if (!user) {
      e.preventDefault();
      navigate("/login");
    } else {
      navigate(href);
    }
  };

  const menuToUse = user ? LOKALAI_MENU : LOKALAI_MENU_Nologin;

  const [openMenu, setOpenMenu] = useState<string | null>(
    user ? "Service History" : "For customers"
  );

  return (
    <div className="AvatarDropdown">
      <Popover className="relative ">
        {({ open }) => (
          <>
            <Popover.Button className="inline-flex items-center focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75">
              {user ? (
                <div
                  className={`flex items-center gap-2 border-0 sm:border sm:border-border dark:sm:border-border px-2 py-1 rounded-full transition ${className}`}
                >
                  <Avatar
                    sizeClass="w-6 h-6 sm:w-7 sm:h-7 "
                    imgUrl={user?.photo}
                    hasChecked={user?.isVerified === true}
                  />
                  <Bars3Icon className={iconClassName} />
                </div>
              ) : (
                <div
                  className={`flex items-center gap-2 border-0 sm:border sm:border-border dark:sm:border-border px-4 py-1 rounded-full transition ${className}`}
                >
                  <span className="hidden sm:inline text-sm font-semibold">
                    Menu
                  </span>
                  <Bars3Icon className={iconClassName} />
                </div>
              )}
            </Popover.Button>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-200"
              enterFrom="opacity-0 translate-y-1"
              enterTo="opacity-100 translate-y-0"
              leave="transition ease-in duration-150"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-1"
            >
              <Popover.Panel className="absolute z-10 w-screen max-w-[350px] px-4 mt-4 -right-10 sm:right-0 sm:px-0 max-h-[90vh] overflow-y-auto scrollbar-thin">
                <div className="overflow-hidden rounded-3xl shadow-lg ring-1 ring-black ring-opacity-5">
                  <div className="relative grid gap-3 bg-white dark:bg-neutral-800 p-7">
                    {user && (
                      <div>
                        <h2 className="text-sm">
                          Welcome back, {user?.displayName}
                        </h2>
                      </div>
                    )}
                    {menuToUse.map((item, index) => (
                      <div key={item.id || index} className="mb-0 ml-2">
                        {item.name === "For customers" && item.children ? (
                          <div className="mb-0">
                            <button
                              onClick={() =>
                                setOpenMenu(
                                  openMenu === item.name ? null : item.name
                                )
                              }
                              className="flex justify-between items-center w-full text-left text-white text-base font-semibold mb-2"
                            >
                              <span>{item.name}</span>
                              <ChevronRightIcon
                                className={`w-4 h-4 transition-transform duration-200 ${
                                  openMenu === item.name ? "rotate-90" : ""
                                }`}
                              />
                            </button>

                            <Transition
                              show={openMenu === item.name}
                              enter="transition-all duration-300 ease-out"
                              enterFrom="opacity-0 max-h-0"
                              enterTo="opacity-100 max-h-[500px]"
                              leave="transition-all duration-300 ease-in"
                              leaveFrom="opacity-100 max-h-[500px]"
                              leaveTo="opacity-0 max-h-0"
                            >
                              <div className="pl-2 mt-4 space-y-4 overflow-hidden ">
                                {item.children.map((child, childIndex) =>
                                  child.action === "loginModal" ? (
                                    <button
                                      key={child.id || childIndex}
                                      onClick={() =>
                                        dispatch(setAuthModalOpen(true))
                                      }
                                      className="flex items-start gap-3 group w-full text-left"
                                    >
                                      {child.icon &&
                                        React.createElement(child.icon, {
                                          className:
                                            "w-7 h-7 text-red-400 shrink-0",
                                        })}
                                      <div>
                                        <p className="text-sm font-semibold text-white group-hover:text-red-400">
                                          {child.name}
                                        </p>
                                      </div>
                                    </button>
                                  ) : (
                                    <a
                                      key={child.id || childIndex}
                                      href={child.href}
                                      onClick={(e) =>
                                        handleLinkClick(e, child.href || "#")
                                      }
                                      className="flex items-center gap-3 group"
                                    >
                                      {child.icon &&
                                        React.createElement(child.icon, {
                                          className:
                                            "w-7 h-7 text-red-400 shrink-0",
                                        })}
                                      <div>
                                        <p className="text-sm font-semibold text-white group-hover:text-red-400">
                                          {child.name}
                                        </p>
                                        {child.name && (
                                          <p className="text-xs text-gray-400">
                                            {child.name}
                                          </p>
                                        )}
                                      </div>
                                    </a>
                                  )
                                )}
                              </div>
                            </Transition>
                          </div>
                        ) : item.children ? (
                          <>
                            <button
                              onClick={() =>
                                setOpenMenu(
                                  openMenu === item.name ? null : item.name
                                )
                              }
                              className="flex justify-between items-center w-full text-left text-text hover:text-red-400  text-base font-semibold mb-2"
                            >
                              <span className="capitalize">{item.name}</span>
                              <ChevronRightIcon
                                className={`w-4 h-4 transition-transform duration-200 ${
                                  openMenu === item.name ? "rotate-90" : ""
                                }`}
                              />
                            </button>

                            <Transition
                              show={openMenu === item.name}
                              enter="transition-all duration-300 ease-out"
                              enterFrom="opacity-0 max-h-0"
                              enterTo="opacity-100 max-h-[500px]"
                              leave="transition-all duration-300 ease-in"
                              leaveFrom="opacity-100 max-h-[500px]"
                              leaveTo="opacity-0 max-h-0"
                            >
                              <div className="pl-2 my-3 space-y-3 overflow-hidden">
                                {item.children.map((child, childIndex) => (
                                  <a
                                    key={child.id || childIndex}
                                    href={child.href}
                                    onClick={(e) =>
                                      handleLinkClick(e, child.href || "#")
                                    }
                                    className="flex items-center gap-3 group"
                                  >
                                    {child.icon &&
                                      React.createElement(child.icon, {
                                        className:
                                          "w-7 h-7 text-red-400 shrink-0",
                                        "aria-hidden": true,
                                      })}
                                    <div>
                                      <p className="text-xs font-normal text-text capitalize group-hover:text-red-400">
                                        {child.name}
                                      </p>
                                      {child.name && (
                                        <p className="text-xs text-gray-400">
                                          {child.subtitle}
                                        </p>
                                      )}
                                    </div>
                                  </a>
                                ))}
                              </div>
                            </Transition>
                          </>
                        ) : (
                          <Link
                            to={item.href || "#"}
                            onClick={() => {
                              if (!user) dispatch(setAuthModalOpen(true));
                            }}
                            className="block text-text hover:text-red-400 text-base font-semibold uppercase"
                          >
                            {item.name}
                          </Link>
                        )}
                      </div>
                    ))}
                  </div>

                  <hr className="h-[1px] border-t border-neutral-300 dark:border-neutral-700" />

                  <div className="flex items-center justify-between py-6 px-5 bg-neutral-800">
                    <a
                      className="inline-block"
                      href="https://demo.lokalai.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <ButtonPrimary className="text-redlight ">
                        Demo <ArrowRightIcon className="ml-2 w-4 h-4" />
                      </ButtonPrimary>
                    </a>
                  </div>

                  <hr className="h-[1px] border-t border-neutral-300 dark:border-neutral-700" />

                  <div className="flex items-center justify-between py-6 px-5 bg-neutral-800">
                    <a
                      className="inline-block"
                      href="https://business.lokalai.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <ButtonPrimary>
                        For Business <ArrowRightIcon className="ml-2 w-4 h-4" />
                      </ButtonPrimary>
                    </a>
                  </div>

                  {user && (
                    <>
                      <hr className="h-[1px] border-t border-neutral-300 dark:border-neutral-700" />
                      <div className="relative grid gap-6 bg-neutral-800 p-7">
                        <a
                          href="#"
                          onClick={handleLogout}
                          className="flex items-center p-2 -m-3 transition duration-150 ease-in-out rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 focus:outline-none focus-visible:ring focus-visible:ring-orange-500 focus-visible:ring-opacity-50"
                        >
                          <div className="flex items-center justify-center flex-shrink-0 text-neutral-500 dark:text-neutral-300">
                            <ArrowRightOnRectangleIcon
                              aria-hidden="true"
                              className="w-6 h-6"
                            />
                          </div>
                          <div className="ml-4">
                            <p className="text-sm font-medium">Logout</p>
                          </div>
                        </a>
                      </div>
                    </>
                  )}
                </div>
              </Popover.Panel>
            </Transition>
          </>
        )}
      </Popover>
    </div>
  );
}
